// 导入封装好的 axios 实例
import request from '@/utils/request'

// 获取设置值
export function getStbReq() {
  return request({
    url: '/program/system/setting/stbRequest',
    method: 'get'
  })
}

// 修改设置值
export function upsetStbReq() {
  return request({
    url: '/program/system/setting/stbRequest',
    method: 'put'
  })
}
